import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "react-query";
import { useClientsState, ClientsState } from "atoms/clientsAtom";

import { deleteClient, getClients, CLIENTS_PAGE_SIZE } from "./index";

const useOnSuccess = () => {
  const queryClient = useQueryClient();
  const { setClientsState } = useClientsState();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-clients"] });
    queryClient.invalidateQueries({ queryKey: ["get-clients-infinite"] });

    setClientsState((prev: ClientsState) => ({
      ...prev,
      activeItems: [],
      activeItem: null
    }));
  };
};

export const useGetClients = () => {
  const { clientsState } = useClientsState();

  return useQuery(
    ["get-clients", clientsState.activeGroupItem?.clientgroupid],
    () => getClients({ clientgroupid: clientsState.activeGroupItem?.clientgroupid })
  );
};

export const useInfiniteClients = (params: {
  clientgroupid?: string | null;
  search?: string;
}) => {
  return useInfiniteQuery(
    ["get-clients-infinite", params.clientgroupid ?? "", params.search ?? ""],
    ({ pageParam = 1 }) =>
      getClients({
        clientgroupid: params.clientgroupid,
        page: pageParam,
        pageSize: CLIENTS_PAGE_SIZE,
        search: params.search,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const list = Array.isArray(lastPage) ? lastPage : [];
        if (list.length < CLIENTS_PAGE_SIZE) return undefined;
        return allPages.length + 1;
      },
      keepPreviousData: false,
    }
  );
};

export const useDeleteClient = () => {
  const onSuccess = useOnSuccess();

  return useMutation(["delete-client"], deleteClient, {
    onSuccess,
  });
};
